import React from 'react'
import { theme } from '../../theme'

const TabHeader = ({ label, isActive, onClick }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '200px',
      padding: '20px 40px',
      borderTopLeftRadius: '10px',
      borderTopRightRadius: '10px',
      backgroundColor: isActive ? theme.colors.secondary : '#cccccc',
      color: isActive ? '#ffffff' : '#000000',
      cursor: 'pointer',
    }}
    onClick={onClick}
  >
    <span style={{ fontSize: 16, fontWeight: 'normal' }}>{label}</span>
  </div>
)

export default TabHeader
